import ProfessionalReview from 'models/ProfessionalReview';
import ProfessionalReviewItem from 'models/ProfessionalReviewItem';

export function getGroupedProfessionalReviews(store) {
    const professionalReviews = store.FeatureContent.Reviews;
    let retval = [];
    if(professionalReviews) {
        const reviews = professionalReviews.reviews;
        if(reviews != null && reviews.length > 0 ) {  
            reviews.forEach(review => {
                let reviewGroup = retval.find(r => r.publicationCode === review.PublicationCode);
                if(reviewGroup) {
                    reviewGroup.reviews.push(new ProfessionalReviewItem(review));
                } else {
                    retval.push(new ProfessionalReview(review));
                }
            })                    
        }
    }
    return retval;
}






// WEBPACK FOOTER //
// ./src/data/ProfessionalReviewSelector.js